import { useContext } from 'react';
import { useMutation, useQuery } from 'react-query';
import { ApiContext } from '../App';
import { EntitiesContext } from '../App';
import * as ActionTypes from '../constants/action-types';

const options = {}
const resource = 'sales';

export const useGetSale = () => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  const sales = useQuery('sale', () => api.get(`/${resource}`), {
    onSuccess: data => entities.dispatch({
      type: ActionTypes.RECEIVE_ENTITIES,
      payload: data.data
    })
  });
  return sales;
}

export const useGetSaleOrders = (id, limit = 10) => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  const orders = useQuery(['sale-orders', limit], () => api.get(`/${resource}/${id}/orders/${limit}`), {
    refetchOnMount: 'always',
    onSuccess: data => entities.dispatch({
      type: ActionTypes.RECEIVE_ENTITIES,
      payload: data.data
    })
  });

  return orders;
}

export const useGetSaleInventory = (sale, role = 'consigner') => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  return useQuery('sale-inventory', () => api.get(`/${resource}/${sale.id}/inventory/${role}`), {
    onSuccess: data => entities.dispatch({
      type: ActionTypes.RECEIVE_ENTITIES,
      payload: data.data
    })
  })
}

export const useDeleteSale = () => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  return useMutation(sale => api.delete(`/${resource}/${sale.id}`), {
    onMutate: sale => entities.dispatch({
      type: ActionTypes.CLEAR_ENTITY,
      payload: {
        type: 'sale',
        id: sale.id
      }
    })
  })
}

export const useCreateSale = () => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  return useMutation(sale => api.post(`/${resource}`, sale), {
    onSuccess: sale => entities.dispatch({
      type: ActionTypes.RECEIVE_ENTITY,
      payload: sale.data
    })
  })
}

export const useSendMassCommunication = () => {
  const api = useContext(ApiContext);

  return useMutation(payload => api.post("/admin/mass/send", { payload: payload }));
}
